import { Button } from '@ps/isp-web-component-library';
import { Link, Translation } from '@ps/web-shared-components';
import { type IspSportsAlias, landingPageEventTypeIds } from '@ps/web-sports-config';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { Message } from '@swf/sports/components';
import { defaultToMatchesTab } from '@swf/sports/hooks/useUrlMenuItems';

import {
  TXTWCL_Return_To_N0,
  TXTWCL_This_event_has_now_finishedX
} from './EventFinishedMessage.messages.json';
import styles from './EventFinishedMessage.scss';

const EventFinishedMessage: React.FC = () => {
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);
  const isEventTypeLandingPage = useSelector((state: RootState) =>
    select.sports.isEventTypeLandingPage(state, { landingPageEventTypeIds })
  );

  let alias: IspSportsAlias = defaultToMatchesTab.includes(Number(eventTypeId))
    ? 'sportsMatchFiltering'
    : 'sportsSport';
  if (isEventTypeLandingPage) alias = 'sportsLanding';

  return (
    <Message message={<Translation {...TXTWCL_This_event_has_now_finishedX} />}>
      <Button
        as={Link}
        alias={alias}
        values={{
          eventTypeId,
          eventTypeSlug
        }}
        className={classNames(styles.titleCase)}
      >
        <Translation values={{ 0: eventTypeSlug }} {...TXTWCL_Return_To_N0} />
      </Button>
    </Message>
  );
};

export default EventFinishedMessage;
